import Marionette from "marionette";
import template from "apps/TrayBar/view/template/TrayBarItemView.html";


let TrayBarItemView = Marionette.ItemView.extend("TrayBarItemView", {
    template,
    className: "TrayBarItemView",
    modelEvents: {
        change: "onChangeModel"
    },
    events: {
        click: "onClick"
    },

    onRender() {
        let count = +this.model.get("count");
        let newCount = +this.model.get("newCount");

        this.$el.toggleClass("TrayBarItemView-zeroCount", count === 0);
        this.$el.toggleClass("TrayBarItemView-zeroNewCount", newCount === 0);

        if ( newCount > 99 ) {
            this.$el.addClass("TrayBarItemView-redOver99");
        } else {
            this.$el.removeClass("TrayBarItemView-redOver99");
        }

        if ( count > 99 || newCount > 99 ) {
            this.$el.addClass("TrayBarItemView-over99");
        } else {
            this.$el.removeClass("TrayBarItemView-over99");
        }
        this.$el.addClass("TrayBarItemView-" + this.model.get("icon"));
    },

    onChangeModel() {
        this.render();
    },

    onClick(e) {
        e.preventDefault();
        this.model.trigger("click");
    }
});

export default TrayBarItemView;
